import { API_HOST } from '@/config';
import client, { ApiRoutes } from '@/store/client';
import { useQuery } from 'react-query';
import { useToast } from '@/hooks/useToast';
import { extractServerErrorMsg, ANNOUNCEMENTS_QUERY_KEY } from '@/queries';
import { Announcement } from '../types';
import { AxiosError } from 'axios';

const getAnnouncements = (featureId?: string) => {
  return () => {
    return client.get<Array<Announcement>>(
      `${API_HOST}/${ApiRoutes.Announcements}/${featureId}/announcements`,
    );
  };
};

export const useGetAnnouncements = (featureId?: string) => {
  const { toast } = useToast();

  const { data, isLoading } = useQuery(
    [ANNOUNCEMENTS_QUERY_KEY, featureId],
    getAnnouncements(featureId),
    {
      enabled: featureId ? true : false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onError: (errorResponse: AxiosError) => {
        toast(extractServerErrorMsg(errorResponse, 'Failed to get announcements.'), {
          variant: 'error',
        });
      },
    },
  );

  const announcements = data?.data;
  return { announcements, isLoading };
};
